// This is to store the transaction parameters for the transaction into KioskDB

export class TransactionParameters {
    public transactionType?: string;
    public transactionStatus?: string;
    public senderName?: string;
    public receiverName?: string;
    public agentId?: string;
    public kioskId?: string;
    public locationName?: string;
    public duration?: string; // C# TimeSpan → string in TS (ISO or hh:mm:ss)
    public isPinCreated?: boolean;
    public isPinUsed?: boolean;
    public language?: string;
    public startTime?: string; // C# DateTimeOffset → string (ISO format) in TS
    public endTime?: string;   // same as above
    public amount?: number;    // C# Decimal → number
    public moneyGramTransactionNumber?: string;
    public lastScreenViewed?: string;
    public screenDurations?: ScreenDuration[];
  }

  export class ScreenDuration {
    public screenName?: string;
    public duration?: string; // C# TimeSpan → string (e.g., "00:05:30") or number (ms)
  }